import {faDropbox} from "@fortawesome/free-brands-svg-icons/faDropbox";
import {faEvernote} from "@fortawesome/free-brands-svg-icons/faEvernote";
import {faGoogleDrive} from "@fortawesome/free-brands-svg-icons/faGoogleDrive";
import {faMicrosoft} from "@fortawesome/free-brands-svg-icons/faMicrosoft";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    AlertBanner,
    Button,
    Card,
    CardLayoutType,
    ColourSolid,
    FlexAlign,
    FlexGap, FlexJustify,
    StackHorizontal,
    StackVertical
} from "@twigsby/frontend-framework";
import {FormatLocaleDate} from "@twigsby/helpers";
import React, {useEffect} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

const AppIntegrations = () => {
    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();

    useEffect(() => {
        updatePageMeta({
            title: t('settings.appIntegrations.title')
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
                <h2 className={'mb-0'}>{t('settings.appIntegrations.title')}</h2>
            </StackHorizontal>

            <StackVertical gap={FlexGap.ExtraLarge}>

                <AlertBanner
                    title={'Dropbox Integration Requires Attention'}
                    content={'Dropbox have updated the way we connect to to your Dropbox account. To continue using the Dropbox integration, you need to reconnect your Dropbox account. Please click the \'Reconnect\' button below to proceed.\n'}
                    colourMod={ColourSolid.Warning}
                />

                <div>
                    <h6 className={'sub-heading mb-xs alert-text'}>{t('status.expired')}</h6>
                    <div className={'card'}>
                        <StackHorizontal gap={FlexGap.Small} extraClass={'p-md'} align={FlexAlign.Center}>
                            <div>
                                <FontAwesomeIcon icon={faDropbox} fixedWidth={true} size={"2x"} />
                            </div>
                            <div className={'flex-column'}>
                                <h6 className={'m-0'}>Dropbox</h6>
                                <div className={'fade'}>{t('settings.appIntegrations.labels.expiredDate', { date : FormatLocaleDate(new Date, currentLocale) })}</div>
                            </div>
                            <div className={'ml-a'}>
                                <Button title={'Reconnect'} squared={true} colour={ColourSolid.Success} />
                            </div>
                        </StackHorizontal>
                    </div>
                </div>

                <div>
                    <Card
                        headerOptions={{
                        title: t('status.active')
                    }}
                          type={CardLayoutType.SlimHeader} emptyBody={true}>
                        <StackHorizontal gap={FlexGap.Small} extraClass={'p-md'} align={FlexAlign.Center}>
                            <div>
                                <FontAwesomeIcon icon={faEvernote} fixedWidth={true} size={"2x"} />
                            </div>
                            <div className={'flex-column'}>
                                <h6 className={'m-0'}>Evernote</h6>
                                <div className={'fade'}>{t('settings.appIntegrations.labels.activatedDate', { date : FormatLocaleDate(new Date, currentLocale) })}</div>
                            </div>
                            <div className={'ml-a'}>
                                <Button title={'Disconnect'} squared={true} />
                            </div>
                        </StackHorizontal>
                    </Card>
                </div>

                <div>
                    <Card
                        headerOptions={{
                            title: t('status.inActive')
                        }}
                        type={CardLayoutType.SlimHeader}
                        emptyBody={true}>

                        <StackHorizontal gap={FlexGap.Small} extraClass={'p-md'} align={FlexAlign.Center}>
                            <div>
                                <FontAwesomeIcon icon={faMicrosoft} fixedWidth={true} size={"2x"} />
                            </div>
                            <div>
                                <h6 className={'m-0'}>One Drive</h6>
                            </div>
                            <div className={'ml-a'}>
                                <Button title={'Connect'} squared={true} />
                            </div>
                        </StackHorizontal>
                        <StackHorizontal gap={FlexGap.Small} extraClass={'p-md'} align={FlexAlign.Center}>
                            <div>
                                <FontAwesomeIcon icon={faGoogleDrive} fixedWidth={true} size={"2x"} />
                            </div>
                            <div>
                                <h6 className={'m-0'}>Google Drive</h6>
                            </div>
                            <div className={'ml-a'}>
                                <Button title={'Connect'} squared={true} />
                            </div>
                        </StackHorizontal>
                    </Card>
                </div>

            </StackVertical>
        </>
    )
}

export default AppIntegrations
